import React from 'react';
import { Input } from '../../Input';

interface SyringeInputProps {
  value: number;
  onChange: (value: number) => void;
  error?: string;
}

export const SyringeInput: React.FC<SyringeInputProps> = ({ value, onChange, error }) => {
  return (
    <Input
      label="Target Syringe Units"
      tooltip="Specify the total insulin syringe units you'd like to pull. For example, 50 units equals 0.5 mL in a U-100 syringe."
      value={value}
      onChange={onChange}
      error={error}
    />
  );
};